import GeckoSocket from '../gecko-socket';
import GeckoStore from '../gecko-store';

export default new Promise((resolve, reject) => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker
      .register('sw.js')
      .then((swReg) => {
        const user = GeckoStore.redux.get('appState.loggedInUser');
        // Only request notification permissions if the user actually has the settings switched on
        if (
          user &&
          (user.additional.desktop_notify_mine ||
            user.additional.desktop_notify_unassigned ||
            user.additional.desktop_notify_other ||
            user.additional.desktop_notify_bot ||
            user.additional.desktop_notify_team)
        ) {
          const messaging = window.firebase.messaging();
          Notification
            .requestPermission()
            .then(function () {
              messaging
                .getToken({ serviceWorkerRegistration: swReg })
                .then(function (currentToken) {
                  if (currentToken && currentToken !== user.additional.FCM_id) {
                    const newAdditional = Object.assign({}, user.additional, {
                      FCM_id: currentToken,
                    });
                    // We need to be a bit careful of this emit as it get's run before the current details of the agent are fetched.  This means it has the potential to overwrite data in the Agents additional property with old data from the token.
                    GeckoSocket.emit(
                      'agents:update',
                      Object.assign({}, user, { additional: newAdditional })
                    );
                  }
                })
                .catch(function (err) {
                  console.log(
                    'An error occurred while retrieving token. ',
                    err
                  );
                });
              messaging.onMessage((payload) => {
                // We can hook into this in the future if we want for an in App notification
                if (!user.additional.desktop_notify_active_tab) return;
                let notification = payload.data;
                if (typeof payload.data === 'string') {
                  notification = JSON.parse(payload.data)
                }
                new Notification(notification.title, notification).onclick = (
                  event
                ) => {
                  event.preventDefault();
                  window.open(notification.click_action, '_blank');
                };
              });
            })
            .catch(function (err) {
              console.log('Unable to get permission to notify.', err);
            });
        }
        resolve(swReg);
      })
      .catch((error) => {
        console.error('Service Worker Error', error);
        reject(error);
      });
  } else {
    console.warn('Push messaging is not supported');
  }
});
